import React from 'react'

const SvgComponent = props => (
  <svg width={54} height={54} {...props}>
    <defs>
      <linearGradient
        x1="-12.039%"
        y1="1.214%"
        x2="155.653%"
        y2="90.79%"
        id="paid__prefix__a"
      >
        <stop stopColor="#FBA4B5" offset="0%" />
        <stop stopColor="#E3486A" offset="100%" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path
        d="M22.55 17.75c-.786.619-1.136 1.425-1.136 2.613 0 2.432 1.377 3.648 3.724 4.775v-8.38c-1.003.149-1.908.458-2.588.992zM31.35 36.127c.843-.755 1.236-1.819 1.236-3.35 0-1.868-1.213-2.821-3.724-3.915v8.38c.98-.19 1.842-.537 2.487-1.115z"
        fill="#F17C95"
      />
      <path
        d="M27 0C12.113 0 0 12.113 0 27s12.113 27 27 27 27-12.113 27-27S41.887 0 27 0zm9.31 32.793c0 2.472-.975 4.479-2.822 5.8-1.307.935-2.978 1.446-4.8 1.664v5.306h-3.375v-5.239c-2.817-.151-5.718-.772-8.112-1.59l-1.597-.544 1.09-3.195 1.599.545c2.154.735 4.676 1.28 7.02 1.433V28.12c-3.752-1.246-7.72-3.061-7.72-7.886 0-2.254 1.02-4.065 2.949-5.236 1.333-.809 3.005-1.234 4.77-1.397V8.438h3.375v5.141c3.08.216 5.998 1.003 7.528 1.8l1.499.777-1.556 2.995-1.498-.777c-1.219-.633-3.558-1.217-5.972-1.411v8.694c3.597 1.152 7.622 2.747 7.622 7.136z"
        fill="url(#paid__prefix__a)"
        fillRule="nonzero"
      />
    </g>
  </svg>
)

export default SvgComponent
